"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventDispatcher = _interopRequireDefault(require("../../../../../event/EventDispatcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/* eslint-disable spaced-comment */
///<reference path="../../../../../../node_modules/@types/leaflet/index.d.ts" />

/* eslint-enable spaced-comment */


var Marker =
/** @class */
function (_super) {
  __extends(Marker, _super);

  function Marker(coord, data, style) {
    var _this = _super.call(this) || this;

    _this.data = data;
    _this._coord = coord;
    _this._feature = new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat([coord.lon, coord.lat]))
    });
    _this._layer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [_this._feature]
      }),
      zIndex: style ? style.zIndex : null
    });
    return _this;
  }

  Object.defineProperty(Marker.prototype, "coordinate", {
    get: function () {
      return this._coord;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Marker.prototype, "feature", {
    get: function () {
      return this._feature;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Marker.prototype, "layer", {
    get: function () {
      return this._layer;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Marker.prototype, "popup", {
    get: function () {
      return this._popup;
    },
    enumerable: false,
    configurable: true
  });

  Marker.prototype.setStyle = function (style) {
    this.feature.setStyle(style);
  };

  Marker.prototype.setPopup = function (popup) {
    this._popup = popup;
  };

  return Marker;
}(_EventDispatcher.default);

var _default = Marker;
exports.default = _default;
module.exports = exports.default;